export default {
  default: {
    title: 'Project Type',
    pleaseSelect: 'Please Select ...',
  },
}
